import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from 'shared/components/ui/use-toast';
import { AssistantActionCreatePortfolioType } from 'types/AssistantTypes';
import ExcelPastOneColumns from './ExcelPastOneColumns';

type ExcelPastOneColumnsWrapperProps = {
  messagePortfolioCast: AssistantActionCreatePortfolioType;
  onActionSubmit: (actionId: string, threadId: string, data: any) => Promise<void>;
};

export const ExcelPastOneColumnsWrapper: React.FC<ExcelPastOneColumnsWrapperProps> = ({
  messagePortfolioCast,
  onActionSubmit,
}) => {
  const { t } = useTranslation();
  const { toast } = useToast();

  // Intercept the submission and use our SDK logic
  const submitAction = useCallback(
    async (threadId: string, actionId: string, data: any) => {
      try {
        await onActionSubmit(actionId, threadId, data);

        toast({
          title: t('global.success'),
          description: t('assistant.setProductsSuccess'),
        });
      } catch (error) {
        console.error('Action submission failed:', error);
        toast({
          title: t('global.error'),
          description: t('global.errorOccurred'),
          variant: 'destructive',
        });
        throw error;
      }
    },
    [onActionSubmit, t, toast],
  );

  return <ExcelPastOneColumns messagePortfolioCast={messagePortfolioCast} onSubmit={submitAction} />;
};
